document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.lien-obfusque').forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      var link = atob(this.getAttribute('data-loc'));
      if (this.getAttribute('blank') === 'true') {
        window.open(link, '_blank');
      } else {
        window.location.href = link;
      }
    });
  });
});
